<template>
  <div>
    <div class="d-flex align-center">
      <AppButton icon
                 class="expand-button"
                 :class="{ 'expand-button--expanded': isRootFolderExpanded }"
                 variant="text"
                 size="x-small"
                 @click="toggleExpand"
      >
        <font-awesome-icon :icon="['fas', 'caret-right']" />
      </AppButton>

      <slot name="root" />
    </div>

    <v-expand-transition>
      <div v-show="isRootFolderExpanded" class="pl-12 pr-4">
        <slot name="children" />
      </div>
    </v-expand-transition>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppButton from '@/common/buttons/AppButton.vue'

export default defineComponent({
  name: 'AppTreeView',
  components: { AppButton },
  props: {
    initiallyExpanded: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      isRootFolderExpanded: this.initiallyExpanded,
    }
  },
  methods: {
    toggleExpand () {
      this.isRootFolderExpanded = !this.isRootFolderExpanded
    },
  },
})
</script>

<style scoped lang="scss">
.expand-button {
  &--expanded {
    transform: rotate(90deg);
  }
}
</style>
